import Moment from 'moment'

export const queryHandler = ( searchParams, page, per_page ) => {
  let tmpFilter = ''
  searchParams.map( item => {
    if ( 
        item.param || 
        typeof( item.param ) === 'boolean'
      ){
      tmpFilter += `"${ item.value }": ${ paramHandler( item ) },`
    }
  })
  return btoa( 
    `{ "page": ${ page } ${ per_page ? `,"per_page": ${ per_page }` : '' } ${ tmpFilter.length > 0 ? `, "filter":{ ${ tmpFilter.slice(0, -1) } }` : '' }}` 
  )
}

const paramHandler = item => {
  if ( item.type === 'date' ){
    return `{"$gt": "${Moment( item.param ).format( 'YYYY-MM-DD' ) + 'T00:00:00.00000Z'}", "$lte": "${Moment( item.param ).format( 'YYYY-MM-DD' ) + 'T23:59:59.00000Z'}"}`
  } 
  if ( typeof( item.param ) === 'number' || typeof( item.param ) === 'boolean' ){
    return item.param
  }

  if ( item.exact ){
    return `{"$like": "${ item.param }" }`
  }

  return `{"$like": "%${ item.param }%" }`
}